import Cookies from 'js-cookie';
import { API_URL } from '@data/constants';

export function isLogged() {
  const accessToken = Cookies.get('access_token');
  const refreshToken = Cookies.get('refresh_token');

  if (!accessToken || !refreshToken) {
    return false;
  }

  return true;
}

export async function login({
  cognitoCode,
}: {
  cognitoCode: string;
}): Promise<{ accessToken: string; refreshToken: string; type: string }> {
  const response = await fetch(`${API_URL}/api/authenticate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ signin_code: cognitoCode }),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error(`Error signing in: ${response.status}`);
  }

  const { data } = (await response.json()) as {
    data: { accessToken: string; refreshToken: string; type: string };
  };

  return data;
}

export async function refreshToken({
  refreshToken,
}: {
  refreshToken: string;
}): Promise<{ accessToken: string; type: string }> {
  const response = await fetch(`${API_URL}/api/refresh-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refreshToken }),
  });

  if (!response.ok) {
    throw new Error('Error refreshing token');
  }

  const { data } = (await response.json()) as {
    data: { accessToken: string; type: string };
  };

  return data;
}
